import { render, staticRenderFns } from "./store-address-modal.vue?vue&type=template&id=b6ff9e70&"
import script from "./store-address-modal.vue?vue&type=script&lang=js&"
export * from "./store-address-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports